import React, { useState, useEffect } from "react";
import "../styles/CommonRemarkPopup.css"

const CommonRemarkPopup = ({ show, onClose, onSave, initialValue, title = "Remarks" }) => {
    const [remarks, setRemarks] = useState("");

    useEffect(() => {
        if (show) {
            setRemarks(initialValue || "");
        }
    }, [show, initialValue]);

    if (!show) return null;

    return (
        <div className="overall-remarks-popup-overlay">
            <div className="overall-remarks-popup">
                <h3 style={{ marginBottom: "10px",fontSize:'18px'}}>{title}</h3>

                <textarea
                    value={remarks}
                    onChange={(e) => setRemarks(e.target.value)}
                    style={{
                        width: "100%",
                        height: "70px",
                        padding: "8px",
                        borderRadius: "6px",
                        border: "1px solid #ccc",
                        boxSizing: "border-box",
                        fontFamily: "Work Sans",
                        resize: "none"
                    }}
                    autoFocus
                />

                <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "10px", gap: "10px" }}>
                    <button className="overall-remarks-btn overall-cancel-btn" onClick={onClose}>
                        Cancel
                    </button>

                    <button className="overall-remarks-btn overall-save-btn" onClick={() => onSave(remarks)}>
                        Save
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CommonRemarkPopup;